import React, { useEffect, useRef } from 'react';
import { useAuth } from './AuthContext';

export default function LoginPage() {
  const { error, clientId } = useAuth();
  const buttonRef = useRef(null);

  useEffect(() => {
    if (!window.google?.accounts?.id || !buttonRef.current || !clientId) return;

    window.google.accounts.id.renderButton(buttonRef.current, {
      theme: 'outline',
      size: 'large',
      type: 'standard',
      text: 'signin_with',
      shape: 'rectangular',
      width: 300,
    });
  }, [clientId]);

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      backgroundColor: '#1a1a2e',
      color: '#e0e0e0',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    }}>
      <img
        src="/sleeper.jpg"
        alt="Sleeper"
        style={{ width: 80, height: 80, borderRadius: 16, marginBottom: 24 }}
      />
      <h1 style={{ fontSize: 24, marginBottom: 8 }}>Risk Homebase</h1>
      <p style={{ color: '#888', marginBottom: 32 }}>Sign in with your @sleeper.app Google account</p>

      <div ref={buttonRef} />

      {error && (
        <p style={{ color: '#ff6b6b', marginTop: 16, maxWidth: 300, textAlign: 'center' }}>
          {error}
        </p>
      )}
    </div>
  );
}
